import React from "react";

type Props = { title?: any; icon?: any; desc?: string };

export default function SectionCard2({ title, icon, desc }: Props) {
  return (
    <>
      <div className="text-center whycards px-20 py-10">
        <img className="pb-10" src={icon} alt={icon} />
        <p className="text-violet-50 font-60 fonts-600 line-70.31 pt-10">
          {title}
        </p>
        <p className="text-black-95 font-20 fonts-400 line-23.44 w-70 m-auto">
          {desc}
        </p>
      </div>
    </>
  );
}
